import React, { Suspense, useEffect, useState } from "react";
import LoadingScreen from "./components/LoadingScreen";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Layout from "./Layout";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BNPLPage from "./pages/BNPLPage";
import ChangerPage from "./pages/ChangerPage";
import SolutionsPage from "./pages/SolutionsPage";
import ContactUs from "./pages/ContactUs";

function App() {
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 2000); 

  return () => clearTimeout(timer);
}, []);

if (loading) return <LoadingScreen />;


  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
      <Layout>
      
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bnpl" element={<BNPLPage />} />
          <Route path="/changer" element={<ChangerPage />} />
          <Route path="/aboutus" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/contactus" element={<ContactUs />} />
        </Routes>
      </Layout>
      </Suspense>
    </Router>
  );
}

export default App;
